import { render, staticRenderFns } from "./AttachmentListSize.vue?vue&type=template&id=8df15fb6&scoped=true"
import script from "./AttachmentListSize.vue?vue&type=script&lang=js"
export * from "./AttachmentListSize.vue?vue&type=script&lang=js"
import style0 from "./AttachmentListSize.vue?vue&type=style&index=0&id=8df15fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df15fb6",
  null
  
)

export default component.exports